import React, { useEffect, useState } from 'react';
import LibraryConfirmationDialog from './LibraryConfirmationDialog';
import LibraryDeployPasswordField from './LibraryDeployPasswordField';
import './LibraryDeployProDialog.scss';

function LibraryDeployProDialog({
  isOpen,
  onCancel,
  onConfirm,
  onClearError = () => {},
  isSubmitting = false,
  error = '',
  fileName = '',
  t,
}) {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (!isOpen) setPassword('');
  }, [isOpen]);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (error) onClearError();
  };

  const handleConfirm = () => onConfirm(password);

  return (
    <LibraryConfirmationDialog
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      title={t('library-confirm-pro-title')}
      description={t('library-confirm-pro-body', { fileName })}
      cancelLabel={t('common-back')}
      confirmLabel={isSubmitting
        ? t('library-confirm-pro-deploying')
        : t('library-action-deploy-pro')}
      confirmDisabled={!password}
      isSubmitting={isSubmitting}
      maxWidth="sm"
      variant="deploy-pro"
    >
      <LibraryDeployPasswordField
        password={password}
        onChange={handlePasswordChange}
        isSubmitting={isSubmitting}
        error={error}
        t={t}
      />
    </LibraryConfirmationDialog>
  );
}

export default LibraryDeployProDialog;
